<template>
  <div class="flex justify-center">
    <div class="flex flex-col gap-y-20 w-1/2 my-50">
      <textarea
        class="message-box"
        :placeholder="$t('write_your_message')"
        v-model="message"
        ref="textarea"
        rows="6"
      >
      </textarea>
      <div class="item-select-box">
        <p class="font-bold">
          {{ $t('only_companies_with_device') }}
        </p>
        <label for="device" class="switcher-label mx-10">
          <input type="checkbox" id="device" class="sr-only" v-model="onlyCompaniesWithDevices" />
          <div class="switcher-inner" />
        </label>
      </div>
      <div class="item-select-box">
        <p class="font-bold">
          {{ $t('only_owners') }}
        </p>
        <label for="owner" class="switcher-label mx-10">
          <input type="checkbox" id="owner" class="sr-only" v-model="onlyOwners" />
          <div class="switcher-inner" />
        </label>
      </div>
      <base-button
        buttonType="primary"
        width="full"
        height="48"
        radius="sm"
        :disabled="!message.length > 0"
        @click.native="submitMessageHandler"
      >
        <template #icon v-if="isLoading">
          <div class="w-18 h-18">
            <base-loading size="full" borderWidth="2"/>
          </div>
        </template>
        <template #text v-else>{{ $t('send_message') }} </template>
      </base-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseButton from '@/components/base/BaseButton.vue';
import convertToBinary from '@/utils/boolean-converter';
import BaseLoading from '@/components/base/BaseLoading.vue';
import serverErrorsHandler from '@/utils/serverErrorsHandler';
import axiosConfig from '@/services/axios.config';

export default {
  name: 'AdminMessage',
  components: { BaseButton, BaseLoading },
  data() {
    return {
      message: '',
      onlyCompaniesWithDevices: false,
      onlyOwners: false,
    };
  },
  computed: {
    ...mapGetters({
      isLoading: 'loading/loadingButton',
    }),
  },
  methods: {
    submitMessageHandler() {
      this.$store.dispatch('loading/buttonLoading', true);
      axiosConfig
        .post('/admin/send-message', {
          message: this.message,
          company_devices: convertToBinary(this.onlyCompaniesWithDevices),
          company_owners: convertToBinary(this.onlyOwners),
        })
        .then((response) => {
          this.$toast.success(response.data.success);
          this.message = '';
          this.$store.dispatch('loading/buttonLoading', false);
        })
        .catch((error) => {
          this.$store.dispatch('loading/buttonLoading', false);
          serverErrorsHandler(error);
          throw error;
        });
    },
  },
};
</script>

<style lang="css" scoped>
.item-select-box {
  @apply flex flex-row items-center justify-between bg-secondary
    border-1 border-default rounded px-30 py-18;
}
.message-box {
  @apply bg-secondary border-1 border-default outline-none rounded focus:ring-0;
}
</style>
